import React, { useState, useContext, useEffect } from "react";
import { ChevronDownIcon } from "../../utils/miscIcons";
import formatCurrency from "../../func/currency_formatter";
import ProductsList from "../productsList";
import DiscountInput from "../inputs/discountInput";
import OrderTotals from "../OrderTotals";
import Separator from "../Separator";
import ExtendedWarrantyCheckbox from "../ExtendedWarrantyCheckbox";
import { TemplateContext } from "../../layout";

const OrderOverviewDrawer = () => {
  const [templateContext, setTemplateContext] = useContext(TemplateContext);
  const [orderOverviewOpen, setOrderOverviewOpen] = useState(true);
  const summary = window.post_template?.checkout_v4_summary;
  const [total, setTotal] = useState();
  const [savings, setSavings] = useState();
  const shippingPolicyUrl = summary.checkout_v4_summary_shippingLink;
  const shippingPrice = Number(templateContext?.config?.product?.shipping_price).toFixed(2);
  let subtotal =
    (templateContext.discountsEnabled &&
      templateContext.discountCode == window.productData.discount_codes.discount_code) ||
    !templateContext.discountsEnabled
      ? templateContext.config?.product?.price * templateContext.config?.product?.amount
      : templateContext.config?.product?.price * templateContext.config?.product?.amount;

  const warrantyAmount = window.productData.multiply_price_by_amount ? templateContext.config?.product?.amount : 1;
  let warrantyPrice = templateContext?.config?.warrantyState
    ? templateContext.config?.product?.warranty_price * warrantyAmount
    : 0.0;

  subtotal = Number(subtotal) + Number(warrantyPrice);

  useEffect(() => {
    let finalSavings = 0;

    templateContext?.config?.product?.fake_products &&
      templateContext.config.product?.fake_products.map((e) => (finalSavings = Number(finalSavings) + Number(e.price)));
    if (
      (templateContext.discountsEnabled &&
        templateContext.discountCode == window.productData.discount_codes.discount_code) ||
      !templateContext.discountsEnabled
    ) {
      finalSavings =
        finalSavings +
        (Number(templateContext.config?.product?.old_price) -
          Number(templateContext.config?.product?.price * templateContext.config?.product?.amount));
    }
    setSavings(finalSavings.toFixed(2));

    const finalPrice = Number(subtotal) + Number(shippingPrice);
    setTotal(finalPrice.toFixed(2));
    setTemplateContext({ ...templateContext, finalPrice: finalPrice });
  }, [subtotal, warrantyPrice]);

  // formatted values
  const oldPrice = templateContext?.config?.warrantyState
    ? Number(templateContext?.config?.product?.old_price) +
      Number(templateContext?.config?.product?.warranty_price) * templateContext?.config?.product?.amount
    : Number(templateContext?.config?.product?.old_price).toFixed(2);

  const formattedTotal = window.formattedString
    ? window.formattedString.replace(/0.00|0,00/g, Number(total).toFixed(2))
    : formatCurrency(Number(total));

  const formattedOldPrice = window.formattedString
    ? window.formattedString.replace(/0.00|0,00/g, Number(oldPrice).toFixed(2))
    : formatCurrency(Number(oldPrice));

  useEffect(() => {
    const initialState = window?.post_template?.checkout_v4_summary.checkout_v4_summary_state;
    if (initialState) {
      setOrderOverviewOpen(initialState);
    }
  }, []);
  return (
    <div
      className={`orderOverviewDrawer ${
        templateContext.withMetaBars || templateContext.withProductHeroSection ? "withBarsContainer" : ""
      }`}
    >
      <div
        className={`orderOverviewDrawer__opener ${orderOverviewOpen ? "_down" : ""} orderOverviewDrawer_label`}
        onClick={() => {
          setOrderOverviewOpen(!orderOverviewOpen);
        }}
      >
        <div className="orderOverviewDrawer_label_title">
          <span style={{ marginRight: "8px" }}>{summary.tr_checkout_v4_order_review_accordion_title}</span>{" "}
          <ChevronDownIcon />
        </div>
        <div className="orderOverviewDrawer_label_priceContainer">
          <div className="orderOverviewDrawer_label_price_old">{formattedOldPrice}</div>
          <div className="orderOverviewDrawer_label_price">{formattedTotal}</div>
        </div>
      </div>

      <div
        style={templateContext?.displayPopup ? { overflow: "visible" } : {}}
        className={`orderOverviewDrawer__content ${orderOverviewOpen && "orderOverviewDrawer__content__show"}`}
      >
        <Separator margin="0px 0px 16px 0px" />
        <ProductsList />
        <Separator margin="16px 0px 16px 0px" />
        <ExtendedWarrantyCheckbox />
        <Separator margin="16px 0px 0px 0px" />
        {templateContext.discountsEnabled && (
          <>
            <DiscountInput />
            <Separator margin="0px 0px 0px 0px" />
          </>
        )}

        <OrderTotals />
      </div>
    </div>
  );
};

export default OrderOverviewDrawer;
